import { component } from 'picoapp';
import Swiper, { EffectFade, Thumbs } from 'swiper';

Swiper.use([EffectFade, Thumbs]);

export default component(async (node) => {
  const swiperThumbsElement: HTMLElement = node.querySelector('[data-swiper-thumbs]');
  const swiperMainElement: HTMLElement = node.querySelector('[data-swiper-main]');

  if (!swiperMainElement) {
    return;
  }

  const swiperThumbs = swiperThumbsElement && new Swiper(swiperThumbsElement, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    threshold: 5,
    breakpoints: {
      1024: {
        direction: 'vertical',
      },
    },
    on: {
      click() {
        swiperThumbs.slideTo(swiperThumbs.clickedIndex);
      }
    }
  });

  (() => new Swiper(swiperMainElement, {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 500,
    ...(swiperThumbs && { thumbs: { swiper: swiperThumbs } }),
  }))();
});
